import { usePointsRequest } from '@/features/points-management/points-request/hooks/usePointsRequest';
import { PointsRequestTable } from '@/features/points-management/points-request/table';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum([
    'requestID',
    'requestedDate',
    'clubInfo',
    'paymentMethod',
    'amountTransferred',
    'status',
    'updatedBy',
    'updatedDate',
  ]),
  desc: z.boolean(),
});

const pointsRequestSearchSchema = z.object({
  sort: z.preprocess((val) => {
    if (typeof val === 'string') {
      try {
        return JSON.parse(val);
      } catch {
        return undefined;
      }
    }
    return val;
  }, z.array(sortItemSchema).optional()),
});

export const Route = createFileRoute('/(app)/points-management/points-request/')({
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => pointsRequestSearchSchema.parse(search),
});

function RouteComponent() {
  const { pointsRequestData } = usePointsRequest();
  return <PointsRequestTable data={pointsRequestData} />;
}
